module.exports = __webpack_public_path__ + "img/老年痴呆.d709b431.png";